import {
	BLACK_MOVED,
	WHITE_MOVED,
	BLACK_CASTLED,
	WHITE_CASTLED,
	BLACK_CAPTURED_WHITE,
	WHITE_CAPTURED_BLACK,
	WHITE_PROMOTED_BY_MOVE,
	BLACK_PROMOTED_BY_MOVE,
	WHITE_PROMOTED_BY_CAPTURE,
	BLACK_PROMOTED_BY_CAPTURE,
	SET_WHITE_CASTLE_STATE,
	SET_BLACK_CASTLE_STATE,
	ADD_HISTORY,
	RESET_HISTORY,
	INITIAL_BOARD,
	SET_GAME_OVER,
} from "./actionTypes";

export function WhiteMoved(whitePosition) {
	return {
		type: WHITE_MOVED,
		payload: { whitePosition },
	};
}

export function BlackMoved(blackPosition) {
	return {
		type: BLACK_MOVED,
		payload: { blackPosition },
	};
}

export function WhiteCastled(whitePosition) {
	return {
		type: WHITE_CASTLED,
		payload: { whitePosition },
	};
}

export function BlackCastled(blackPosition) {
	return {
		type: BLACK_CASTLED,
		payload: { blackPosition },
	};
}

export function SetWhiteCastleState(canWhiteCastle) {
	return {
		type: SET_WHITE_CASTLE_STATE,
		payload: { canWhiteCastle },
	};
}

export function SetBlackCastleState(canBlackCastle) {
	return {
		type: SET_BLACK_CASTLE_STATE,
		payload: { canBlackCastle },
	};
}

export function WhiteCapturedBlack(whitePosition, blackPosition) {
	return {
		type: WHITE_CAPTURED_BLACK,
		payload: { whitePosition, blackPosition },
	};
}

export function BlackCapturedWhite(whitePosition, blackPosition) {
	return {
		type: BLACK_CAPTURED_WHITE,
		payload: { whitePosition, blackPosition },
	};
}

export function WhitePromotedByMove(whitePiece, whitePosition) {
	return {
		type: WHITE_PROMOTED_BY_MOVE,
		payload: { whitePiece, whitePosition },
	};
}
export function BlackPromotedByMove(blackPiece, blackPosition) {
	return {
		type: BLACK_PROMOTED_BY_MOVE,
		payload: { blackPiece, blackPosition },
	};
}
export function WhitePromotedByCapture(whitePiece, whitePosition, blackPosition) {
	return {
		type: WHITE_PROMOTED_BY_CAPTURE,
		payload: { whitePiece, whitePosition, blackPosition },
	};
}
export function BlackPromotedByCapture(blackPiece, whitePosition, blackPosition) {
	return {
		type: BLACK_PROMOTED_BY_CAPTURE,
		payload: { blackPiece, whitePosition, blackPosition },
	};
}

export function AddHistory(history) {
	console.log("ADD_HISTORY", ADD_HISTORY, history);
	return {
		type: ADD_HISTORY,
		payload: { history },
	};
}

export function ResetHistory() {
	return {
		type: RESET_HISTORY,
	};
}

export function SetGameOver(gameOver) {
	console.log("SET_GAME_OVER", SET_GAME_OVER, gameOver);
	return {
		type: SET_GAME_OVER,
		payload: { gameOver },
	};
}

export function InitialPosition(board) {
	const {
		whitePosition,
		blackPosition,
		whitePiece,
		blackPiece,
		canWhiteCastle,
		canBlackCastle,
		history,
		isWhiteTurn,
		gameOver,
	} = board;
	return {
		type: INITIAL_BOARD,
		payload: {
			whitePosition,
			blackPosition,
			whitePiece,
			blackPiece,
			canWhiteCastle,
			canBlackCastle,
			history,
			isWhiteTurn,
			gameOver,
		},
	};
}
